import { render, staticRenderFns } from "./overview-subpage.vue?vue&type=template&id=2e607a5e&lang=pug&"
import script from "./overview-subpage.vue?vue&type=script&lang=js&"
export * from "./overview-subpage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports